var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseHeaderMain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#007C76",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.655.022 19.82 18.186l-1.135 1.135L.52 1.158z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.52 18.186 18.684.022l1.135 1.136L1.655 19.32z"
})))));
export default SvgCloseHeaderMain;